
const digest = '38d9bee7a3ff58ea5eac2727b03fc5948f0ce51d0af294c6c4076e63c014df50';
const classes = {"wrapper":"_wrapper_csf5t_1","upper":"_upper_csf5t_7","lower":"_lower_csf5t_11"};
const css = `._wrapper_csf5t_1 {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

._upper_csf5t_7 {
  bottom: 20%;
}

._lower_csf5t_11 {
  top: 20%;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  